export const shouldBlockVoucherReferrer = (route, referrer) => {
  if (route?.meta?.name !== 'voucher' || !referrer) {
    return false
  }

  try {
    // URL의 경로나 쿼리가 아닌 호스트를 비교해 네이버의 하위 도메인까지 차단한다.
    const hostname = new URL(referrer).hostname.toLowerCase().replace(/\.$/, '')
    return hostname === 'naver.com' || hostname.endsWith('.naver.com')
  } catch {
    return false
  }
}
